import React from 'react';
import rus from './russia.jpg';
import eng from './england.jpg';
import './lang.scss';

const Lang = ({ switchLang }) => (
  <div className='switchLang' onClick={switchLang}>
    <img id='ru' width='30' src={rus} alt='russian' />
    <img id='en' width='30' src={eng} alt='english' />
  </div>
);

export default Lang;
